export default __webpack_public_path__ + "static/media/chat.719f283c.png";